export type { TFunction } from 'i18next';
export { Trans, useTranslation } from 'react-i18next';

export { createI18n } from './create-i18n.js';
export { I18nProvider } from './I18nProvider.js';
